import React from 'react';
import {marked} from "marked";
import {Button} from "../../../icymat-design/Button";
import {Textarea} from "../../../icymat-design/Textarea";


export class Markdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            mode: 'view',
            editedContent: this.props.file.content
        };
        this.textareaRef = React.createRef();
    }

    handleQueryTextChange = (event) => {
        const textarea = event.target;
        this.setState({editedContent: event.target.value, textareaHeight: textarea.scrollHeight});
    };

    render() {
        const parsedHtml = marked.parse(this.state.editedContent);

        return (
            <div>
                <Button
                    icon={'imd-icon imd-icon-xmark'}
                    onClick={() => this.props.saveFile(this.props.file.id, this.state.editedContent, true)}
                />
                <Button
                    icon={'imd-icon imd-icon-' + (this.state.mode === 'view' ? 'edit-pencil' : 'align-left')}
                    secondary={true}
                    onClick={() => {this.setState({mode: this.state.mode === 'edit' ? 'view' : 'edit'})}}
                />

                <div style={{maxHeight: '75vh', overflow: 'auto', display: this.state.mode === 'view' ? 'block' : 'none'}}>
                    <div className={'imd-border-color-accent imd-text-accent'} style={{width: '100%', maxWidth: '800px', border: '1px solid', margin: '0 auto', padding: '26px'}}>
                        <span dangerouslySetInnerHTML={{ __html: parsedHtml }} />
                    </div>
                </div>

                <Textarea
                    forwarderRef={this.textareaRef}
                    value={this.state.editedContent}
                    height={'80vh'}
                    onChange={(e) => this.handleQueryTextChange(e)}
                    onBlur={() => {this.props.saveFile(this.props.file.id, this.state.editedContent, false)}}
                    style={{width: '100%', display: this.state.mode === 'edit' ? 'block' : 'none'}}
                />
            </div>
        );
    }
}
